import { IntlShape } from 'react-intl'
import { create, enforce, test } from 'vest'
import { MaximumUnitPriceDiscount } from '../../../../../../../typings'
import messages from './messages'

const MIN_VALUE = 0

export function validationSuite(intl: IntlShape) {
  return create(({ price }: MaximumUnitPriceDiscount) => {
    const { $t } = intl
    const { validation } = messages

    test(`price`, $t(validation.gt, { value: MIN_VALUE }), () => {
      enforce(price).gt(MIN_VALUE)
    })
  })
}
